import {
    getData,
    postData
  } from './api-base.service'

  export const createWorkflowModel = (defaultType = 1, phone = null, defaultYear = 0, defaultCourseId = 0) => {
    return {
      Id: 0,
      Enable: true,
      Type: defaultType,
      FeeYear: defaultYear,
      SubType: null,
      StudentId: 0,
      Amount: 0,
      Quantity: 1,
      TotalPrice: 0,
      Comment: null,
      BalanceCost: 0,
      BonusPointCost: 0,
      BonusPointPrice: 0,
      BonusPointExchangeItemId: 0,
      PaymentCommissionCost: 0,
      IsCompleted: false,
      AccountId: null,
      Phone: phone,
      GiftBalanceId: null,
      GiftAmount: null,
      CourseId: defaultCourseId || null
    };
}

export const getWorkflowData = (id = null) => {
    let data = {
      id: id
    };
    let fetchResult = getData('/OtherCollectFee/GetWorkflowData', data);
  
    return fetchResult;
}

export const getWorkflowDataByAccountId = (accountId) => {
  let data = {
    accountId: accountId
  };
  let fetchResult = getData('/OtherCollectFee/GetWorkflowDataByAccountId', data);

  return fetchResult;
}

export const saveWorkflowData = (saveModel) => {
  let data = saveModel;
  let fetchResult = postData('/OtherCollectFee/SaveWorkflowData', data);

  return fetchResult;
}

export const getGiftBalances = (hasDefault, getAll) => {
  if (typeof hasDefault == undefined){
    hasDefault = true;
  }
  if (typeof getAll == undefined){
    getAll = false;
  }
  let result = getData('/OtherCollectFee/GetGiftBalances', {hasDefault: hasDefault, getAll: getAll});
  return result;
}

export const saveGiftBalances = (data) => {
  let result = postData('/OtherCollectFee/SaveGiftBalances', data);
  return result;
}


// WEBPACK FOOTER //
// ./src/service/otherCollectFee.service.js